import { render, staticRenderFns } from "./Text.vue?vue&type=template&id=03aa8a86"
import script from "./Text.js?vue&type=script&lang=js&external"
export * from "./Text.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports